import { Component, type ReactNode } from 'react';
import { reportError } from '../telemetry';
import { failureReason } from './failure';
import { FailurePanel } from './FailurePanel';

interface State {
  failure: string | null;
}

/**
 * A render error anywhere in the page no longer leaves it white: the player is told, the error
 * is reported, and a reload is one press away (client-audio-engine:quality#1).
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { failure: null };

  static getDerivedStateFromError(error: unknown): State {
    return { failure: failureReason(error) };
  }

  override componentDidCatch(error: unknown): void {
    reportError(error, 'The page');
  }

  override render() {
    if (this.state.failure === null) return this.props.children;
    return <FailurePanel title="The game stopped" reason={this.state.failure} />;
  }
}
